/* ============================================================
   REIKON — theme.js
   Cart drawer (AJAX) · Quick-add · Product gallery · Video reel
   · Qty steppers · Upsell · Sticky CTA · Accordions · Reveal
   · Mobile nav · Search · Password email capture
   All interactions hook onto data-* attributes (the JS contract).
   ============================================================ */
(() => {
  'use strict';
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const money = (cents) => {
    try {
      const cfg = window.Shopify && window.Shopify.currency;
      return new Intl.NumberFormat(document.documentElement.lang || 'de', {
        style: 'currency', currency: (cfg && cfg.active) || 'EUR'
      }).format(cents / 100);
    } catch (e) { return '€' + (cents / 100).toFixed(2); }
  };
  const t = (key, fallback) => (window.REIKON_STRINGS && window.REIKON_STRINGS[key]) || fallback;

  /* ---------------- CART DRAWER ---------------- */
  const drawer  = $('[data-cart-drawer]');
  const overlay = $('[data-cart-overlay]');
  const openCart = () => { drawer && drawer.classList.add('is-open'); overlay && overlay.classList.add('is-open'); drawer && drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; };
  const closeCart = () => { drawer && drawer.classList.remove('is-open'); overlay && overlay.classList.remove('is-open'); drawer && drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; };
  $$('[data-cart-toggle]').forEach(b => b.addEventListener('click', (e) => { e.preventDefault(); drawer && drawer.classList.contains('is-open') ? closeCart() : openCart(); }));
  overlay && overlay.addEventListener('click', closeCart);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { closeCart(); closeMobileNav(); closeSearch(); } });

  const FREE_SHIP_THRESHOLD = parseInt(drawer && drawer.getAttribute('data-free-ship') || '0', 10); // in cents

  /* Free-Ship-Balken aktualisieren – wird im GANZEN Drawer gesucht (nicht nur im Footer) */
  function updateShipBar(cart) {
    const bar = $('[data-ship-fill]'), msg = $('[data-ship-msg]');
    if (!bar || FREE_SHIP_THRESHOLD <= 0) return;
    const pct = Math.min(100, (cart.total_price / FREE_SHIP_THRESHOLD) * 100);
    bar.style.width = pct + '%';
    if (msg) {
      const remain = FREE_SHIP_THRESHOLD - cart.total_price;
      msg.innerHTML = remain > 0
        ? t('ship_remain', 'Nur noch {x} bis zum Gratisversand!').replace('{x}', '<strong>' + money(remain) + '</strong>')
        : '<strong>' + t('ship_unlocked', 'Gratisversand freigeschaltet ✓') + '</strong>';
    }
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('is-empty', cart.item_count === 0); });
    updateShipBar(cart);
    const body = $('[data-cart-body]');
    if (!body) return;
    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-empty"><p>' + t('cart_empty', 'Dein Warenkorb ist leer.') + '</p><a href="/collections/all" class="btn btn--outline" data-cart-toggle>' + t('continue', 'Weiter shoppen') + '</a></div>';
      const f = $('[data-cart-footer]'); if (f) f.hidden = true;
      $$('[data-cart-toggle]', body).forEach(b => b.addEventListener('click', closeCart));
      return;
    }
    // line items
    let html = '';
    cart.items.forEach(item => {
      const opt = (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : '';
      const img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      html += `<div class="cart-line" data-line-key="${item.key}">
        <a href="${item.url}" class="cart-line__img">${img ? `<img src="${img}" alt="" loading="lazy" width="64" height="80">` : ''}</a>
        <div class="cart-line__info">
          <a href="${item.url}" class="cart-line__title">${item.product_title}</a>
          ${opt ? `<div class="cart-line__opt">${opt}</div>` : ''}
          <div class="cart-line__qty">
            <button type="button" class="cart-line__step" data-line-dec aria-label="-">&minus;</button>
            <span>${item.quantity}</span>
            <button type="button" class="cart-line__step" data-line-inc aria-label="+">+</button>
            <button type="button" class="cart-line__remove" data-line-remove>${t('remove','Entfernen')}</button>
          </div>
        </div>
        <div class="cart-line__price">${money(item.final_line_price)}</div>
      </div>`;
    });
    body.innerHTML = html;
    // bind qty / remove
    $$('[data-line-key]', body).forEach(line => {
      const key = line.getAttribute('data-line-key');
      const qty = parseInt(line.querySelector('.cart-line__qty span').textContent, 10);
      line.querySelector('[data-line-inc]').addEventListener('click', () => changeLine(key, qty + 1));
      line.querySelector('[data-line-dec]').addEventListener('click', () => changeLine(key, qty - 1));
      line.querySelector('[data-line-remove]').addEventListener('click', () => changeLine(key, 0));
    });
    // footer
    const footer = $('[data-cart-footer]');
    if (footer) {
      footer.hidden = false;
      const sub = $('[data-cart-subtotal]', footer); if (sub) sub.textContent = money(cart.total_price);
    }
    refreshUpsell(cart);
  }

  async function fetchCart() { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); return r.json(); }
  async function changeLine(key, quantity) {
    try {
      const r = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const cart = await r.json(); renderCart(cart);
    } catch (e) { console.error(e); }
  }

  async function addToCart(formData, opts = {}) {
    const r = await fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } });
    if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || 'add failed'); }
    const cart = await fetchCart(); renderCart(cart);
    if (opts.open !== false) openCart();
    return cart;
  }

  /* ---------------- PRODUCT FORM (AJAX) ---------------- */
  $$('[data-product-form]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const label = btn && btn.querySelector('[data-btn-label]');
      const original = label ? label.textContent : (btn && btn.textContent);
      if (btn) { btn.disabled = true; if (label) label.textContent = t('adding','Wird hinzugefügt…'); else btn.textContent = t('adding','Wird hinzugefügt…'); }
      try {
        await addToCart(new FormData(form));
        if (btn) { if (label) label.textContent = t('added','Hinzugefügt ✓'); else btn.textContent = t('added','Hinzugefügt ✓'); }
        setTimeout(() => { if (btn) { btn.disabled = false; if (label) label.textContent = original; else btn.textContent = original; } }, 1100);
      } catch (err) {
        console.error(err);
        if (btn) { btn.disabled = false; if (label) label.textContent = original; else btn.textContent = original; }
        alert(err.message || t('add_error','Konnte nicht zum Warenkorb hinzugefügt werden.'));
      }
    });
  });

  /* ---------------- QUICK-ADD (cards, reels, upsell) ---------------- */
  document.addEventListener('click', async (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    const id = q.getAttribute('data-variant-id');
    if (!id) { window.location = q.getAttribute('data-product-url') || '#'; return; }
    const orig = q.textContent; q.disabled = true; q.textContent = t('adding','…');
    try { const fd = new FormData(); fd.append('id', id); fd.append('quantity', q.getAttribute('data-qty') || 1); await addToCart(fd); q.textContent = t('added','✓'); }
    catch (err) { console.error(err); q.textContent = t('add_error','Fehler'); }
    finally { setTimeout(() => { q.disabled = false; q.textContent = orig; }, 1100); }
  });

  /* ---------------- UPSELL (in cart drawer) ---------------- */
  function refreshUpsell(cart) {
    const wrap = $('[data-upsell]'); if (!wrap) return;
    const ids = cart.items.map(i => String(i.product_id));
    let anyShown = false;
    $$('[data-upsell-item]', wrap).forEach(el => {
      const pid = el.getAttribute('data-product-id');
      const show = pid && !ids.includes(pid);
      el.hidden = !show; if (show) anyShown = true;
    });
    wrap.hidden = !anyShown;
  }

  /* ---------------- PRODUCT GALLERY ---------------- */
  $$('[data-gallery]').forEach(gallery => {
    const slides = $$('[data-slide]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    const prev = $('[data-gallery-prev]', gallery);
    const next = $('[data-gallery-next]', gallery);
    const total = slides.length; if (!total) return;
    let cur = 0;
    const go = (i) => {
      cur = (i + total) % total;
      slides.forEach((s, k) => s.classList.toggle('is-active', k === cur));
      thumbs.forEach((s, k) => s.classList.toggle('is-active', k === cur));
      const active = thumbs[cur]; if (active && active.scrollIntoView) active.scrollIntoView({ inline: 'nearest', block: 'nearest', behavior: 'smooth' });
    };
    thumbs.forEach((th, k) => th.addEventListener('click', () => go(k)));
    prev && prev.addEventListener('click', () => go(cur - 1));
    next && next.addEventListener('click', () => go(cur + 1));
    if (total < 2) { prev && (prev.style.display = 'none'); next && (next.style.display = 'none'); }
  });

  /* ---------------- VIDEO REELS ---------------- */
  /* select the actual <video> inside each reel — robust even if the data attr is missing */
  $$('[data-reel] video, [data-reel-video]').forEach(v => {
    v.muted = true; v.playsInline = true; v.setAttribute('playsinline', '');
    /* Lazy: erst abspielen (und damit laden) wenn im Sichtbereich – spart Bandbreite beim Seitenaufbau */
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(ents => ents.forEach(en => {
        if (en.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
      }), { threshold: 0.25 });
      io.observe(v);
    } else {
      v.play().catch(() => {});
    }
    const wrap = v.closest('[data-reel]');
    if (wrap) {
      const mute = wrap.querySelector('[data-reel-mute]');
      mute && mute.addEventListener('click', (e) => { e.stopPropagation(); v.muted = !v.muted; wrap.classList.toggle('is-unmuted', !v.muted); });
      wrap.addEventListener('click', () => { v.paused ? v.play().catch(() => {}) : v.pause(); });
    }
  });

  /* ---------------- QTY STEPPERS ---------------- */
  $$('[data-qty-input]').forEach(input => {
    const p = input.parentElement;
    const dec = p.querySelector('[data-qty-minus]'), inc = p.querySelector('[data-qty-plus]');
    dec && dec.addEventListener('click', () => { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); input.dispatchEvent(new Event('change')); });
    inc && inc.addEventListener('click', () => { input.value = (parseInt(input.value, 10) || 1) + 1; input.dispatchEvent(new Event('change')); });
  });

  /* ---------------- STICKY CTA ---------------- */
  const sticky = $('[data-sticky-cta]'), buyForm = $('[data-product-form]');
  if (sticky && buyForm) {
    // Sticky-CTA erst zeigen, wenn man UNTER der ganzen Produkt-Section (.pp) ist
    // – nicht schon, sobald nur das Kauf-Formular aus dem Bild scrollt.
    const watch = sticky.closest('.pp') || buyForm;
    new IntersectionObserver(ents => ents.forEach(en => sticky.classList.toggle('is-visible', !en.isIntersecting)), { threshold: 0 }).observe(watch);
    const sb = sticky.querySelector('[data-sticky-buy]');
    sb && sb.addEventListener('click', () => buyForm.querySelector('[type=submit]').click());
  }

  /* ---------------- ACCORDIONS ---------------- */
  $$('[data-accordion] [data-acc-item]').forEach(item => {
    const btn = item.querySelector('[data-acc-trigger]'), panel = item.querySelector('[data-acc-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', () => {
      const open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.style.maxHeight = open ? panel.scrollHeight + 'px' : '0';
    });
  });

  /* ---------------- MOBILE NAV ---------------- */
  const mnav = $('[data-mobile-nav]');
  function closeMobileNav() { mnav && mnav.classList.remove('is-open'); if (!drawer || !drawer.classList.contains('is-open')) { overlay && overlay.classList.remove('is-open'); document.body.style.overflow = ''; } }
  function openMobileNav() { mnav && mnav.classList.add('is-open'); overlay && overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
  $$('[data-mobile-nav-toggle]').forEach(b => b.addEventListener('click', () => mnav && mnav.classList.contains('is-open') ? closeMobileNav() : openMobileNav()));
  mnav && $$('a', mnav).forEach(a => a.addEventListener('click', closeMobileNav));

  /* ---------------- SEARCH ---------------- */
  const search = $('[data-search]');
  function openSearch() { search && search.classList.add('is-open'); document.body.style.overflow = 'hidden'; setTimeout(() => { const i = search && search.querySelector('input[type=search]'); i && i.focus(); }, 80); }
  function closeSearch() { search && search.classList.remove('is-open'); if (!drawer || !drawer.classList.contains('is-open')) document.body.style.overflow = ''; }
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', openSearch));
  search && search.addEventListener('click', e => { if (e.target === search || e.target.hasAttribute('data-search-close')) closeSearch(); });

  /* ---------------- PASSWORD EMAIL (storefront lock) ---------------- */
  // handled natively by Shopify form; just add UX state
  $$('[data-password-form]').forEach(f => {
    f.addEventListener('submit', () => { const b = f.querySelector('[type=submit]'); if (b) { b.disabled = true; b.textContent = t('sending','…'); } });
  });

  /* ---------------- REVEAL ON SCROLL ---------------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    const io = new IntersectionObserver(ents => ents.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    reveals.forEach(el => io.observe(el));
  } else { reveals.forEach(el => el.classList.add('is-in')); }

  /* ---------------- INIT: sync cart count on load ---------------- */
  if ($('[data-cart-count]')) { fetchCart().then(renderCart).catch(() => {}); }

  // expose for inline section scripts if needed
  window.REIKON = { openCart, closeCart, addToCart, fetchCart, renderCart, money };
})();